import {
  library,
  config,
  findIconDefinition,
  type IconName,
} from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import {
  faArrowRight,
  faBullhorn,
  faScaleBalanced,
  faGear,
  faCoins,
  faPenRuler,
  faDiagramProject,
  faCircleQuestion,
  faQuoteLeft,
  faCheck,
  faClone,
  faChevronDown,
  faCube,
  faLanguage,
  faUsers,
  faCodeBranch,
  faPalette,
  faBolt,
  faRocket,
  faLayerGroup,
  faMoon,
  faSun,
  faDesktop,
  faPencil,
  faHighlighter,
  faLink,
  faList,
  faCheckCircle,
  faCalendar,
  faEnvelope,
  faShareNodes,
  faLocationDot,
  faPhone,
  faBrain,
  faWandMagicSparkles,
  faGauge,
  faBarsProgress,
  faTurnUp,
  faSearch,
  faCircleInfo,
  faDownload,
  faXmark,
  faPuzzlePiece,
  faTags,
  faDatabase,
  faClock,
  faMicrochip,
  faChevronUp,
  faTerminal,
  faChevronLeft,
  faChevronRight,
  // @custom-start [Task: Additional content icons]
  faBoxesStacked,
  faChartLine,
  faRoute,
  faQuestion,
  faFileContract,
  faClipboardCheck,
  faUserTie,
  faBan,
  faTriangleExclamation,
  faUserGraduate,
  faFlask,
  faShieldHalved,
  faTruckField,
  faMicroscope,
  faBell,
  faFileLines,
  faFileSignature,
  faMapPin,
  faFile,
  faFilePdf,
  faFileCode,
  faFileExport,
  faFileImport,
  faFileInvoiceDollar,
  faMap,
  faThumbtack,
  faQuoteRight,
  faFilter,
  // @custom-end
  // faFloppyDisk carries the `save` alias that the picker offers.
  faGripVertical,
  faWrench,
  faGlobe,
  faArrowUp,
  faArrowDown,
  faTrash,
  faPlus,
  faFloppyDisk,
  faCircleExclamation,
  faSpinner,
  // @custom-start [Task: Icons for this instance's extra picker options]
  // Compliance, trust & certification
  faShield,
  faShieldHeart,
  faUserShield,
  faFileShield,
  faCertificate,
  faAward,
  faMedal,
  faStamp,
  faLock,
  // Audit, quality & checklists
  faClipboardList,
  faListCheck,
  faSquareCheck,
  faGavel,
  faMagnifyingGlassChart,
  // Food safety specifics
  faThermometer,
  faSnowflake,
  faDroplet,
  faLeaf,
  faSeedling,
  faUtensils,
  faBiohazard,
  faHelmetSafety,
  // Operations & supply chain
  faIndustry,
  faWarehouse,
  faTruckFast,
  faGears,
  faNetworkWired,
  faServer,
  // Analytics & growth
  faChartPie,
  faChartColumn,
  faChartSimple,
  faChartArea,
  faArrowTrendUp,
  faArrowTrendDown,
  faBullseye,
  // Business & people
  faBriefcase,
  faHandshake,
  faChalkboardUser,
  faComments,
  // Platform & notifications
  faMobileScreen,
  faCloudArrowUp,
  faCloudArrowDown,
  faFlagCheckered,
  // @custom-end
} from '@fortawesome/free-solid-svg-icons'
import {
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Prevent Font Awesome from adding its CSS since we did it manually above:
config.autoAddCss = false

// Register the icons the site can render from a stored string name. This must
// cover every option the admin icon picker offers: the picker previews from an
// icon map, so an unregistered option looks correct in the editor and renders
// nothing on the page.
library.add(
  faArrowRight,
  faBullhorn,
  faScaleBalanced,
  faGear,
  faCoins,
  faPenRuler,
  faDiagramProject,
  faCircleQuestion,
  faQuoteLeft,
  faCheck,
  faClone,
  faChevronDown,
  faCube,
  faLanguage,
  faUsers,
  faCodeBranch,
  faPalette,
  faBolt,
  faRocket,
  faLayerGroup,
  faMoon,
  faSun,
  faDesktop,
  faPencil,
  faHighlighter,
  faLink,
  faList,
  faCheckCircle,
  faCalendar,
  faEnvelope,
  faShareNodes,
  faLocationDot,
  faPhone,
  faBrain,
  faWandMagicSparkles,
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube,
  faGauge,
  faBarsProgress,
  faTurnUp,
  faSearch,
  faCircleInfo,
  faDownload,
  faXmark,
  faPuzzlePiece,
  faTags,
  faDatabase,
  faClock,
  faMicrochip,
  faChevronUp,
  faTerminal,
  faChevronLeft,
  faChevronRight,
  // @custom-start [Task: Additional content icons]
  faBoxesStacked,
  faChartLine,
  faRoute,
  faQuestion,
  faFileContract,
  faClipboardCheck,
  faUserTie,
  faBan,
  faTriangleExclamation,
  faUserGraduate,
  faFlask,
  faShieldHalved,
  faTruckField,
  faMicroscope,
  faBell,
  faFileLines,
  faFileSignature,
  faMapPin,
  faFile,
  faFilePdf,
  faFileCode,
  faFileExport,
  faFileImport,
  faFileInvoiceDollar,
  faMap,
  faThumbtack,
  faQuoteRight,
  faFilter,
  // @custom-end
  faGripVertical,
  faWrench,
  faGlobe,
  faArrowUp,
  faArrowDown,
  faTrash,
  faPlus,
  faFloppyDisk,
  faCircleExclamation,
  faSpinner,
  // @custom-start [Task: Icons for this instance's extra picker options]
  // The admin picker (inertia/admin/components/ui/iconOptions.ts) offers options
  // this instance added, and the picker previews from an icon map — so an option
  // missing here still looks correct in the editor while rendering nothing on the
  // public page. Every option this instance adds must be registered below.
  faShield,
  faShieldHeart,
  faUserShield,
  faFileShield,
  faCertificate,
  faAward,
  faMedal,
  faStamp,
  faLock,
  faClipboardList,
  faListCheck,
  faSquareCheck,
  faGavel,
  faMagnifyingGlassChart,
  faThermometer,
  faSnowflake,
  faDroplet,
  faLeaf,
  faSeedling,
  faUtensils,
  faBiohazard,
  faHelmetSafety,
  faIndustry,
  faWarehouse,
  faTruckFast,
  faGears,
  faNetworkWired,
  faServer,
  faChartPie,
  faChartColumn,
  faChartSimple,
  faChartArea,
  faArrowTrendUp,
  faArrowTrendDown,
  faBullseye,
  faBriefcase,
  faHandshake,
  faChalkboardUser,
  faComments,
  faMobileScreen,
  faCloudArrowUp,
  faCloudArrowDown,
  faFlagCheckered
  // @custom-end
)

export { FontAwesomeIcon }

/**
 * Helper to resolve an icon name to a FontAwesome icon prop.
 * Handles both solid and brand icons registered in the library.
 */
export function getIconProp(name: string): any {
  if (!name) return null

  // Ask the library rather than matching against a hardcoded list of brand
  // names, so registering a new brand icon above is enough to make it render.
  if (findIconDefinition({ prefix: 'fab', iconName: name as IconName })) {
    return ['fab', name]
  }

  // Default to solid
  return name
}
